import { getAuthVersion } from "@/services/authorization";
import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";
interface updateInfoProps {
  id: number;
  version: string;
  timestamp: number;
  update_content: string[];
  win_download_info: string;
  mac_download_info: string;
  is_mandatory_update?: boolean;
  created_at: number;
  updated_at: number;
}
class Store {
  isUpdate = false;
  version = "0";
  isSkip = false;
  isShow = false;
  promptly = false;
  updateInfo: updateInfoProps;
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "ClientUpdate",
      properties: ["isUpdate", "version", "isSkip"],
      storage: window.localStorage,
    });
  }
  @action setUpdateStatus = (status) => {
    this.isShow = status;
    this.isUpdate = status;
  };
  @action setIsShow = (status) => {
    this.isShow = status;
  };
  @action setIsSkip = (status) => {
    this.isSkip = status;
  };
  @action setIsPromptly = (status) => {
    this.promptly = status;
  };
  @action setUpdateInfo = (data) => {
    this.updateInfo = data;
    runInAction(() => {
      this.setUpdateStatus(data.version !== this.version);
    });
  };

  @action setVersion = (version) => {
    this.version = version;
  };
}

const ClientUpdate = new Store();
export default ClientUpdate;
